"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("../../services/core");
var _reactstrap = require("reactstrap");
var _icon = _interopRequireDefault(require("wever-core/dist/components/common/icon"));
var _referent = _interopRequireDefault(require("./referent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultReferent = {
  job: '',
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  gender: 'genre_nsp',
  job: 'job_representant_dirigeant'
};
const Referents = _ref => {
  let {
    alias,
    value,
    parent,
    onChange,
    form,
    min,
    jobs
  } = _ref;
  const defaultReferents = value || [{
    ...defaultReferent
  }];
  const [referents, setReferents] = (0, _react.useState)(defaultReferents);
  const updateCard = (index, field, value) => {
    const tmp = [...referents];
    tmp[index][field] = value;
    setReferents(tmp);
    onChange(tmp);
  };
  const onDelete = index => {
    const tmp = [...referents];
    tmp.splice(index, 1);
    setReferents(tmp);
    onChange(tmp);
  };
  (0, _react.useEffect)(() => {
    if (min && (!value || value.length === 0)) {
      const baseReferent = [];
      for (let i = 0; i < min; i++) {
        baseReferent.push({
          ...defaultReferent,
          job: jobs[i],
          delete: false
        });
      }
      setReferents(baseReferent);
    }
    return () => {
      setReferents([{
        ...defaultReferent
      }]);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: alias
  }, referents.map((referent, index) => {
    return /*#__PURE__*/_react.default.createElement(_referent.default, {
      key: 'stack_' + alias + '_' + index,
      parent: parent,
      index: index,
      value: referent,
      alias: alias,
      onChange: updateCard,
      onDelete: onDelete,
      form: form
    });
  }), /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    onClick: () => referents.length < 11 && setReferents([...referents, {
      ...defaultReferent
    }]),
    className: "btn-wever-red rounded-pill"
  }, (0, _core._translate)('registerapp_club_add_referent'), " ", /*#__PURE__*/_react.default.createElement(_icon.default, {
    name: "plus"
  })));
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Referents);